import { Injectable, Injector } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SomethingWentWrongModalComponent } from './something-went-wrong-modal.component';

/**
 * Opens the "Something went wrong" modal. Used by InterceptorService for network/5xx
 * failures and by ApiService for its request timeouts. The page is never reloaded from
 * here — only when the user clicks "Reload" in the modal.
 */
@Injectable({
  providedIn: 'root'
})
export class SomethingWentWrongService {
  // Several requests usually fail together; only one modal at a time.
  private isOpen = false;

  // BsModalService is resolved lazily: it depends on ApplicationRef, which depends on
  // ErrorHandler, which depends on ApiService -> this service. Injecting it in the
  // constructor closes that loop (NG0200 circular dependency).
  constructor(private injector: Injector) { }

  show() {
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    const modalRef = this.injector.get(BsModalService).show(SomethingWentWrongModalComponent, {
      // something-went-wrong-dialog: hook for the global rule in styles.scss that keeps the
      // card intact when another modal leaks .modal-content styles (see there).
      class: 'modal-dialog-centered something-went-wrong-dialog',
      // Reload is the only way out, as in the design: no backdrop click, no Esc.
      backdrop: 'static',
      keyboard: false
    });
    modalRef.onHidden?.subscribe(() => {
      this.isOpen = false;
    });
  }
}
